import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () =>
      import('@ls/feature-app-layout').then((m) =>
        m.createAppLayoutRoutes([
          {
            path: '',
            loadChildren: () =>
              import('@le/feature-home').then(
                ({ featureHomeRoutes }) => featureHomeRoutes
              ),
          },
        ])
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('@le/feature-fullscreen-layout').then((m) => m.routes),
  },
  { path: '**', redirectTo: '' },
];
